module.exports = __webpack_public_path__ + "img/share_tag_03.2258cf67.png";